import React, { useState } from 'react';
import { Mail, Send, Users, Eye, MousePointerClick, TrendingUp, Calendar, Search, Filter, MoreVertical, Edit, Copy, Trash2, ChevronDown } from 'lucide-react';
const campaigns = [{
  id: 1,
  name: 'Nuovi Immobili Retail - Milano Centro',
  subject: 'Opportunità esclusive nel Quadrilatero',
  sentDate: '2024-01-15',
  recipients: 45,
  opened: 38,
  clicked: 22,
  status: 'completed'
}, {
  id: 2,
  name: 'Showroom Disponibili - Brera',
  subject: 'Spazi premium per il tuo brand',
  sentDate: '2024-01-10',
  recipients: 32,
  opened: 28,
  clicked: 15,
  status: 'completed'
}, {
  id: 3,
  name: 'Investment Opportunities Q1',
  subject: 'Portfolio immobiliare selezionato',
  sentDate: '2024-01-05',
  recipients: 18,
  opened: 16,
  clicked: 12,
  status: 'completed'
}];
export function SentCampaigns() {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const totalSent = campaigns.reduce((sum, c) => sum + c.recipients, 0);
  const totalOpened = campaigns.reduce((sum, c) => sum + c.opened, 0);
  const totalClicked = campaigns.reduce((sum, c) => sum + c.clicked, 0);
  const avgOpenRate = (totalOpened / totalSent * 100).toFixed(1);
  const avgClickRate = (totalClicked / totalSent * 100).toFixed(1);
  return <div className="space-y-6" data-id="element-1035">
      <div className="flex items-center justify-between" data-id="element-1036">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1037">
          Campagne Inviate
        </h1>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1038">
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1039">
          <div className="flex items-center gap-3 mb-2" data-id="element-1040">
            <div className="w-10 h-10 bg-[#1388ad]/10 rounded-lg flex items-center justify-center" data-id="element-1041">
              <Send className="w-5 h-5 text-[#1388ad]" data-id="element-1042" />
            </div>
            <div data-id="element-1043">
              <p className="text-sm text-gray-500" data-id="element-1044">Campagne Inviate</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-1045">
                {campaigns.length}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1046">
          <div className="flex items-center gap-3 mb-2" data-id="element-1047">
            <div className="w-10 h-10 bg-[#1388ad]/10 rounded-lg flex items-center justify-center" data-id="element-1048">
              <Eye className="w-5 h-5 text-[#1388ad]" data-id="element-1049" />
            </div>
            <div data-id="element-1050">
              <p className="text-sm text-gray-500" data-id="element-1051">Tasso Apertura</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-1052">
                {avgOpenRate}%
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1053">
          <div className="flex items-center gap-3 mb-2" data-id="element-1054">
            <div className="w-10 h-10 bg-[#1388ad]/10 rounded-lg flex items-center justify-center" data-id="element-1055">
              <MousePointerClick className="w-5 h-5 text-[#1388ad]" data-id="element-1056" />
            </div>
            <div data-id="element-1057">
              <p className="text-sm text-gray-500" data-id="element-1058">Tasso Click</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-1059">
                {avgClickRate}%
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1060">
          <div className="flex items-center gap-3 mb-2" data-id="element-1061">
            <div className="w-10 h-10 bg-[#1388ad]/10 rounded-lg flex items-center justify-center" data-id="element-1062">
              <Users className="w-5 h-5 text-[#1388ad]" data-id="element-1063" />
            </div>
            <div data-id="element-1064">
              <p className="text-sm text-gray-500" data-id="element-1065">Destinatari Totali</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-1066">
                {totalSent}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1067">
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-1068">
          <div className="flex-1" data-id="element-1069">
            <div className="relative" data-id="element-1070">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1071" />
              <input type="text" placeholder="Cerca campagne..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1072" />
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1073">
            <Filter className="w-4 h-4" data-id="element-1074" />
            <span className="text-sm" data-id="element-1075">Filtri</span>
          </button>
        </div>
      </div>
      {/* Campaigns List */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1076">
        <div className="overflow-x-auto" data-id="element-1077">
          <table className="w-full" data-id="element-1078">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1079">
              <tr data-id="element-1080">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1081">
                  Campagna
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1082">
                  Data Invio
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1083">
                  Destinatari
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1084">
                  Aperture
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1085">
                  Click
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1086">
                  Stato
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1087">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1088">
              {campaigns.map(campaign => {
              const openRate = (campaign.opened / campaign.recipients * 100).toFixed(1);
              const clickRate = (campaign.clicked / campaign.recipients * 100).toFixed(1);
              return <tr key={campaign.id} className="hover:bg-gray-50" data-id="element-1089">
                    <td className="px-6 py-4" data-id="element-1090">
                      <div data-id="element-1091">
                        <p className="text-sm font-medium text-gray-900" data-id="element-1092">
                          {campaign.name}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-1093">
                          {campaign.subject}
                        </p>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-1094">
                      <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-1095">
                        <Calendar className="w-4 h-4" data-id="element-1096" />
                        {new Date(campaign.sentDate).toLocaleDateString('it-IT')}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-1097">
                      <div className="flex items-center gap-2" data-id="element-1098">
                        <Users className="w-4 h-4 text-gray-400" data-id="element-1099" />
                        <span className="text-sm text-gray-900" data-id="element-1100">
                          {campaign.recipients}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-1101">
                      <div data-id="element-1102">
                        <p className="text-sm font-medium text-gray-900" data-id="element-1103">
                          {campaign.opened}
                        </p>
                        <p className="text-xs text-[#1388ad]" data-id="element-1104">{openRate}%</p>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-1105">
                      <div data-id="element-1106">
                        <p className="text-sm font-medium text-gray-900" data-id="element-1107">
                          {campaign.clicked}
                        </p>
                        <p className="text-xs text-[#1388ad]" data-id="element-1108">{clickRate}%</p>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-1109">
                      <span className="px-2 py-1 text-xs font-medium rounded-full bg-[#1388ad]/10 text-[#1388ad]" data-id="element-1110">
                        Completata
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-1111">
                      <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1112">
                        <MoreVertical className="w-4 h-4 text-gray-400" data-id="element-1113" />
                      </button>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}